import { useEffect, useState } from "react";
import { Quote, Star } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";

export const BookReviews = () => {
  const [reviews, setReviews] = useState([]);
  useEffect(() => { api.get("/books/reviews").then((r) => setReviews(r.data)).catch(() => {}); }, []);
  if (!reviews.length) return null;

  return (
    <section className="py-24" style={{ backgroundColor: "#FBF8F1" }} data-testid="book-reviews">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="overline mb-4" style={{ color: "var(--gold)" }}>From our families</p>
          <h2 className="font-display text-4xl md:text-5xl mb-12" style={{ color: "var(--navy)" }}>Loved at <span className="italic" style={{ color: "var(--turquoise)" }}>bedtime.</span></h2>
        </Reveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <Reveal key={r.id} delay={(i % 3) * 0.08}>
              <figure className="h-full p-8 rounded-2xl bg-white border flex flex-col" style={{ borderColor: "rgba(212,175,55,0.3)" }} data-testid={`book-review-${i}`}>
                <div className="flex gap-1 mb-4">{[0, 1, 2, 3, 4].map((s) => <Star key={s} size={14} fill="#D4AF37" stroke="#D4AF37" />)}</div>
                <Quote size={20} style={{ color: "var(--turquoise)" }} />
                <blockquote className="font-display text-xl leading-snug mt-3 flex-1" style={{ color: "var(--navy)" }}>“{r.quote}”</blockquote>
                <figcaption className="overline mt-6" style={{ color: "var(--muted)" }}>{r.attribution}</figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
